import { Component, Output, EventEmitter, Input, SimpleChanges, ViewChild } from "@angular/core";
import { OnInit, OnChanges } from "@angular/core";
import { ProductoService } from "./producto.service";
import { ObjetoContrato } from "../../Modelos/ObjetoContrato";
import { Producto } from "../../Modelos/Producto";
import { Amparo } from "../../Modelos/Amparo";
import { AmparosComponent } from "./amparo/amparos.component";

declare let obtenerFecha: Function;
declare let actualizarCampos: Function;
declare let renderizarDatePickers: Function;
declare let mostrarToast: Function;
declare let desactivarFechas: Function;
declare let convertirAFecha: Function;
declare let formatearFecha: Function;
declare let validarFormatoFecha: Function;

@Component({
    selector: 'producto',
    templateUrl: 'producto.component.html',
    styleUrls: ["producto.component.css"]
})
export class ProductoComponent implements OnInit, OnChanges {
    @Input() producto: Producto;
    @Input() codigoRamo: number;
    @Input() flagEmision: boolean;
    @Input() codigoAgencia: number;
    @Input() seriedadDeLaOferta: boolean;
    @Output() alternarLoader=new EventEmitter();
    @ViewChild(AmparosComponent, {static: false}) amparos;
    isSafari: boolean;

    constructor(private productoService: ProductoService) { }
    
    clausulados: any[];
    girosNegocio: any[];
    objetosContrato: ObjetoContrato[];
    valorPrimaMinima: number;
    parametrosVigencia: any;


    detectSafari(): boolean {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1;
    }

    async ngOnChanges(changes: SimpleChanges){
        const isSafari = this.detectSafari();
        this.alternarLoader.emit();
        let codigoRamo=this.codigoRamo==null?0:this.codigoRamo;
        if(changes.hasOwnProperty("codigoRamo") && changes.codigoRamo.currentValue!=null){
            await this.filtrarObjetosContrato(changes.codigoRamo.currentValue);
            await this.consultarClausulados(changes.codigoRamo.currentValue);
            await this.consultarGirosNegocio(changes.codigoRamo.currentValue);
            this.parametrosVigencia=await this.productoService.consultarParametrosVigencia(changes.codigoRamo.currentValue);
            let agencia=this.codigoAgencia==null?0:this.codigoAgencia;
            if(agencia!=0)
                this.valorPrimaMinima=await this.productoService.consultarValorPrimaMinima(changes.codigoRamo.currentValue, agencia);

            let fechaEmision: Date=await this.productoService.consultarFechaEmision(agencia);
            this.producto.fechaExpedicion=fechaEmision.toLocaleDateString("es-CO", {});
            const isSafari = false
            if(isSafari){
            desactivarFechas(
                "ProductoFechaVigenciaDesde",
                new Date(fechaEmision.getFullYear(), fechaEmision.getMonth(), fechaEmision.getDate()-this.parametrosVigencia.dias_retroactivos),
                new Date(fechaEmision.getFullYear(), fechaEmision.getMonth(), fechaEmision.getDate()+this.parametrosVigencia.dias_posteriores));
            }
        }
        if(changes.hasOwnProperty("codigoAgencia") && changes.codigoAgencia.currentValue!=null){
            let retroactividad=120;
            let futuridad=120;

            if(codigoRamo!=0){
                retroactividad=this.parametrosVigencia.dias_retroactivos;
                futuridad=this.parametrosVigencia.dias_posteriores;
                this.valorPrimaMinima=await this.productoService.consultarValorPrimaMinima(this.codigoRamo, changes.codigoAgencia.currentValue);
            }

            let agencia=changes.codigoAgencia.currentValue==null?0:changes.codigoAgencia.currentValue;
            let fechaEmision: Date=await this.productoService.consultarFechaEmision(agencia);
            this.producto.fechaExpedicion=fechaEmision.toLocaleDateString("es-CO", {});
            const isSafari = false
            if(isSafari){
                desactivarFechas(
                    "ProductoFechaVigenciaDesde",
                    new Date(fechaEmision.getFullYear(), fechaEmision.getMonth(), fechaEmision.getDate()-retroactividad),
                    new Date(fechaEmision.getFullYear(), fechaEmision.getMonth(), fechaEmision.getDate()+futuridad));
            }

        }
        if(changes.hasOwnProperty("seriedadDeLaOferta")){
            await this.filtrarObjetosContrato(codigoRamo);
            await this.consultarGirosNegocio(codigoRamo);
        }
        actualizarCampos();
        this.alternarLoader.emit();
    }

    async filtrarObjetosContrato(codigoRamo: number){
        if(this.codigoRamo!=0){
            let objetosContratoResultado=await this.productoService.consultarObjetosContrato(this.codigoRamo);

            if(codigoRamo!=74){

                if(this.seriedadDeLaOferta)
                    objetosContratoResultado=objetosContratoResultado.filter(x => x.descripcion.toLowerCase().includes("pliego"));
                else
                    objetosContratoResultado=objetosContratoResultado.filter(x => !x.descripcion.toLowerCase().includes("pliego"));
            }

            this.objetosContrato = [...objetosContratoResultado];
            this.restablecerObjetoContrato();
            this.producto.amparos=[];
        }
    }

    ngOnInit() {
        this.alternarLoader.emit();
        renderizarDatePickers();
        this.clausulados = [];
        this.objetosContrato=[];

        let d = new Date();
        let date = [
            ('0' + d.getDate()).slice(-2),
            ('0' + (d.getMonth() + 1)).slice(-2),
            d.getFullYear()
        ].join('/');

        this.producto = {
            valorContrato: "",
            fechaExpedicion: date,
            clausulado: null,
            amparos: [],
            fechaFinConstitucion: "",
            fechaVigenciaDesde: "",
            giroNegocio: 0,
            numeroContrato: "",
            objetoContrato: 0
        };
        
        actualizarCampos();
        this.alternarLoader.emit();
    }

    async consultarClausulados(codigoRamo: number = 0) {
        this.clausulados = [...(await this.productoService.consultarClausulados(codigoRamo))];
        this.producto.clausulado=null;
    }

    async consultarGirosNegocio(codigoRamo: number = 0){
        this.girosNegocio = [...(await this.productoService.consultarGirosNegocio(codigoRamo))];
        if(this.seriedadDeLaOferta){
            this.girosNegocio = [...this.girosNegocio.filter(x=>x.descripcionGiroNegocio=="SERIEDAD DE LA OFERTA")];
        }
        this.producto.giroNegocio=null;
    }

    async consultarAmparos(){
        this.alternarLoader.emit();
        let amparos=await this.productoService.consultarAmparos(this.codigoRamo, this.codigoAgencia, '1', this.producto.objetoContrato);
        if(this.seriedadDeLaOferta)
            amparos=amparos.filter(x => x.codigo_subramo!=12);
        this.producto.amparos=amparos.map((amparo: Amparo) => this.construirAmparo(amparo));
        actualizarCampos();
        this.alternarLoader.emit();
    }

    construirAmparo(amparo){
        amparo.id_amparo=parseInt(`${amparo.codigo_amparo}${amparo.codigo_objeto}${amparo.codigo_ramo_tec}${amparo.codigo_subramo}`);
        amparo.descripcion_amparo=(this.codigoRamo==74)?amparo.descripcion_amparo:amparo.descripcion_subramo;
        amparo.cod_deducible=null;
        amparo.suma_es_porcentaje=false;
        amparo.valido=false;
        amparo.aaaa=0;
        amparo.mm=0;
        amparo.dd=0;
        amparo.total_dias=1;
        amparo.tipo_calculo=1;
        amparo.tipo_tasa=null;
        amparo.vr_prima_minima=this.valorPrimaMinima;
        amparo.dias_inicio_vigencia=(amparo.dias_inicio_vigencia==0)?3650:amparo.dias_inicio_vigencia;
        if(amparo.es_Postcontractual==-1)
            amparo.fecha_vigencia_desde=this.producto.fechaFinConstitucion;
        else
            amparo.fecha_vigencia_desde=this.producto.fechaVigenciaDesde;
        return amparo;
    }    

    validarValorContrato(){
        this.producto.valorContrato=(this.producto.valorContrato+'').replace(/[^\d.]+/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        actualizarCampos();
    }

    validarNumeroContrato(){
        this.producto.numeroContrato=this.producto.numeroContrato.replace(/[^\d a-zA-Zá-úÁ-ÚñÑ/*-]+/g, '');
    }

    restablecerObjetoContrato(){
        this.producto.objetoContrato=null;
        actualizarCampos();
    }

    obtenerProductoFechaVigenciaDesde(){
        this.producto.fechaVigenciaDesde=obtenerFecha("ProductoFechaVigenciaDesde");
        let fvd: Date=convertirAFecha(this.producto.fechaVigenciaDesde);

        if(!validarFormatoFecha(this.producto.fechaVigenciaDesde)){
            this.producto.fechaVigenciaDesde="";
            return;
        }

        let fe=this.producto.fechaExpedicion.split("/").map(x=>parseInt(x));
        
        if(this.producto.fechaFinConstitucion){
            if(convertirAFecha(this.producto.fechaFinConstitucion)<fvd){
                mostrarToast("La fecha fin de contrato no puede ser inferior a la fecha vigencia desde.");
                this.producto.fechaFinConstitucion="";
            }
        }

        let retroactividad: number=this.parametrosVigencia.dias_retroactivos;
        if(fvd<new Date(fe[2], fe[1]-1, fe[0]-retroactividad)){
            mostrarToast(`La retroactividad no puede ser mayor los ${retroactividad} días.`);
            this.producto.fechaVigenciaDesde="";
            return;
        }

        let futuridad: number=this.parametrosVigencia.dias_posteriores;
        if(fvd>new Date(fe[2], fe[1]-1, fe[0]+futuridad)){
            mostrarToast(`La futuridad no puede ser mayor a los ${futuridad} días.`);
            this.producto.fechaVigenciaDesde="";
            return;
        }

        let hoy=new Date();

        if(fvd<hoy){
            desactivarFechas("ProductoFechaFinConstitucion", hoy);
        }
        else{
            desactivarFechas("ProductoFechaFinConstitucion", fvd);
        }
    }

    obtenerProductoFechaFinConstitucion(){
        this.producto.fechaFinConstitucion=obtenerFecha("ProductoFechaFinConstitucion");

        if(!validarFormatoFecha(this.producto.fechaFinConstitucion)){
            this.producto.fechaFinConstitucion="";
            return;
        }

        let ffc: Date=convertirAFecha(this.producto.fechaFinConstitucion);

        if(this.producto.fechaVigenciaDesde!=""){
            if(ffc<convertirAFecha(this.producto.fechaVigenciaDesde)){
                mostrarToast("La fecha fin de contrato no puede ser menor a la fecha vigencia desde.");
                this.producto.fechaFinConstitucion="";
                return;
            }
        }

        if(ffc<new Date()){
            mostrarToast("La fecha fin de contrato no puede ser menor a la fecha actual.");
            this.producto.fechaFinConstitucion="";
            return;
        }
    }

    formatearFechaDesde(fechaDesde: string) {
        this.producto.fechaVigenciaDesde = this.formatearFechaManualProducto(fechaDesde);
    }

    formatearFechaFin(fechaFin: string) {
        this.producto.fechaFinConstitucion = this.formatearFechaManualProducto(fechaFin);
    }

private formatearFechaManualProducto(valor: string): string {
    if (!valor) {
        return '';
    }

    let limpio = valor.replace(/[^\d/]/g, '');

    const slashCount = (limpio.match(/\//g) || []).length;

    if (slashCount > 0) {
        let partes = limpio.split('/');

        let dia = partes.length > 0 ? partes[0].replace(/\D/g, '').substring(0, 2) : '';
        let mes = partes.length > 1 ? partes[1].replace(/\D/g, '').substring(0, 2) : '';
        let anio = partes.length > 2 ? partes[2].replace(/\D/g, '').substring(0, 4) : '';

        if (partes.length === 2 && mes.length === 2 && limpio.endsWith('/')) {
            return dia + '/' + mes + '/';
        }

        if (partes.length === 2 && mes.length === 2 && limpio.length > 5) {
            const numeros = limpio.replace(/\D/g, '');
            anio = numeros.substring(4, 8);
            return dia + '/' + mes + '/' + anio;
        }

        let resultado = dia;

        if (partes.length > 1 || limpio.indexOf('/') >= 0) {
            resultado += '/' + mes;
        }

        if (partes.length > 2) {
            resultado += '/' + anio;
        }

        return resultado;
    }

    const numeros = limpio.replace(/\D/g, '');

    if (numeros.length <= 2) {
        return numeros;
    }

    if (numeros.length <= 4) {
        return numeros.substring(0, 2) + '/' + numeros.substring(2);
    }

    return numeros.substring(0, 2) +
           '/' +
           numeros.substring(2, 4) +
           '/' +
           numeros.substring(4, 8);
}

    validarFormatoFecha(fecha){
        if(!validarFormatoFecha(fecha)){
            mostrarToast("El formato de fecha no es válido.");
        }
    }

}